import * as React from 'react';
import { Body2 } from '@cian/ui-kit';

import { ILinkCell } from '../../../../../../types/newbuildingsCompare';

export interface ILinkCellProps {
  cell: ILinkCell;
}

export const LinkCell = ({ cell }: ILinkCellProps): React.JSX.Element => (
  <Body2>{cell.data?.text ?? cell.state.text ?? ''}</Body2>
);
